// extracted by mini-css-extract-plugin
module.exports = {"container":"hB3gyUo2sVZ9AmZTFuDe4"};